import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import { GetEmployeeByReDocument } from './schema.graphql';
import { GetEmployeeByReQuery, GetEmployeeByReQueryVariables } from 'src/app/model/employee';


@Injectable({
  providedIn: 'root'
})
export class GetEmployeeByReGQL extends Apollo.Query<GetEmployeeByReQuery, GetEmployeeByReQueryVariables> {
  document = GetEmployeeByReDocument;
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
